import { render, staticRenderFns } from "./PreviewProduct.vue?vue&type=template&id=6407900b&scoped=true&"
import script from "./PreviewProduct.vue?vue&type=script&lang=js&"
export * from "./PreviewProduct.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProduct.vue?vue&type=style&index=0&id=6407900b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6407900b",
  null
  
)

export default component.exports